import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { ExpanderComponent } from '../expander/expander.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { mainConfiguration } from '../../../configuration/main';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { HelpComponent } from '../help/help.component';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'adf-global-application-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdownModule,
    RouterLink,
    ExpanderComponent,
    NotificationsComponent,
    UserMenuComponent,
    HelpComponent,
  ],
  templateUrl: './global-application-toolbar.component.html',
  styleUrl: './global-application-toolbar.component.scss',
})
export class GlobalApplicationToolbarComponent {
  private readonly _authService = inject(AuthenticationService);

  isNotError = signal(true);
  isSettingsLoaded = signal(false);
  title = computed(() => mainConfiguration.title);
  private readonly currentUser = this._authService.currentUser;
  userName = computed(() => this.currentUser()?.name);

  onLogout() {
    this._authService.logout();
  }
}
